import React from 'react';

import { StatusBarProps } from './StatusBar.PropType';

class StatusBar extends React.Component<StatusBarProps> {
  render() {
    return null;
  }
}
export default StatusBar;
